import className from "classnames/bind";
import { Button } from "@components";

import styles from "./CarouselPagination.module.scss";
import { forwardRef, useEffect } from "react";
import { useCarouselOffset } from "@/providers/CarouselOffsetContext";
import { getLinkData } from "@/core/utils";
import { usePageWrapperData } from "@/providers/PageWrapperContext";
const cx = className.bind(styles);

interface CarouselPaginationProps {
  className?: string;
  ctaIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  cta?: {
    linkType?: string[];
    label?: string;
    externalLink?: string;
    page?: {
      node?: {
        uri?: string;
      };
    }
  }
}

const CarouselPagination = forwardRef<HTMLDivElement, CarouselPaginationProps>(({ className, cta, ctaIcon }, ref) => {
  const { updateContainerEl } = useCarouselOffset();
  const { labels } = usePageWrapperData();
  useEffect(updateContainerEl, [])
  const ctaData = cta && getLinkData(cta);
  const centerMobile = !ctaData;
  return (
    <div className={cx(["carousel-pagination", className, "carousel-paging", { "center-mobile": centerMobile }])} ref={ref}>

      <div
        className={cx("splide__pagination", "carousel-pagination__pagination")}
      />

      <div className={cx("splide__arrows", "carousel-pagination__arrows")}>
        <button className="splide__arrow splide__arrow--prev" aria-label={labels?.ariaLabels?.prevButton}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
            <path className="circle" d="M20,.75h0c10.63,0,19.25,8.62,19.25,19.25h0c0,10.63-8.62,19.25-19.25,19.25h0C9.37,39.25.75,30.63.75,20h0C.75,9.37,9.37.75,20,.75Z" fill="transparent" stroke="currentColor" strokeWidth="1.5"/>
            <path className="arrow" d="M18,25v-10l5,5-5,5Z" fill="currentColor" />
          </svg>
        </button>
        <button className={cx("splide__arrow", "splide__arrow--next", "next-arrow")} aria-label={labels?.ariaLabels?.nextButton}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
            <path className="circle" d="M20,.75h0c10.63,0,19.25,8.62,19.25,19.25h0c0,10.63-8.62,19.25-19.25,19.25h0C9.37,39.25.75,30.63.75,20h0C.75,9.37,9.37.75,20,.75Z" fill="transparent" stroke="currentColor" strokeWidth="1.5"/>
            <path className="arrow" d="M18,25v-10l5,5-5,5Z" fill="currentColor" />
          </svg>
        </button>
      </div>
      {ctaData && ( <Button className={cx("cta")} {...ctaData} icon={ctaIcon} /> )}
    </div>
  );
});

export default CarouselPagination;
